import React from "react";
import { useField, ErrorMessage } from "formik";
import InputError from "../input-error/input-error";
import Select from "./select.component";
import { SelectOption } from "./select.component";

type FormikSelectProps = {
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  showLabel?: boolean;
  label?: string;
  id: string;
  name: string;
  onChange?: (value: string, name: string) => void;
};

const FormikSelect: React.FC<FormikSelectProps> = ({
  options,
  placeholder,
  className,
  disabled,
  showLabel,
  label,
  id,
  name,
  onChange,
}) => {
  const [field, meta, helpers] = useField(name);
  const hasError = meta.touched && !!meta.error;

  const handleChange = (value: string, fieldName: string) => {
    helpers.setValue(value);
    helpers.setTouched(true);
    onChange?.(value, fieldName);
  };

  const handleBlur = () => {
    helpers.setTouched(true);
  };

  return (
    <>
      <Select
        options={options}
        value={field.value}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
        showLabel={showLabel}
        label={label}
        id={id}
        name={name}
        hasError={hasError}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <ErrorMessage name={name} component={InputError} />
    </>
  );
};

export default FormikSelect;
